import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThemeMode, DarkModeValue } from '../../utils/constants';

interface ThemeState {
  currentMode: ThemeMode;
  darkModeFromParent: DarkModeValue;
  isThemeInitialized: boolean;
}

const initialState: ThemeState = {
  currentMode: 'light',
  darkModeFromParent: 'LIGHT',
  isThemeInitialized: false,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setDarkModeFromParent: (state, action: PayloadAction<DarkModeValue>) => {
      state.darkModeFromParent = action.payload;
      // Case-neutral comparison for parent dark mode value
      const isDark = action.payload?.toString().toUpperCase() === 'DARK';
      state.currentMode = isDark ? 'dark' : 'light';
      state.isThemeInitialized = true;
    },
    setThemeMode: (state, action: PayloadAction<ThemeMode>) => {
      state.currentMode = action.payload;
    },
    initializeTheme: (state) => {
      if (!state.isThemeInitialized) {
        // Default to light mode if parent hasn't provided theme info yet
        state.currentMode = 'light';
        state.darkModeFromParent = 'LIGHT';
        state.isThemeInitialized = true;
      }
    },
  },
});

export const { setDarkModeFromParent, setThemeMode, initializeTheme } = themeSlice.actions;

// Selectors
export const selectCurrentThemeMode = (state: { theme: ThemeState }) => state.theme.currentMode;
export const selectDarkModeFromParent = (state: { theme: ThemeState }) => state.theme.darkModeFromParent;
export const selectIsThemeInitialized = (state: { theme: ThemeState }) => state.theme.isThemeInitialized;

export default themeSlice.reducer;